import React, { useContext } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, NavLink, useRouteMatch } from 'react-router-dom'
import * as globals from '../../globals'
import * as apiService from '../../utils/apiService'
import { actionCreators } from '../../store/Study.ts'
import './TopBar.scss'
import { ThemeContext } from '../../ThemeProvider'

export function UserMenu() {

  const { changeTheme } = useContext(ThemeContext)
  const dispatch = useDispatch()
  
  const study = useSelector(state => state.study)
  const user = useSelector(state => state.auth?.user)
  const auth = useSelector(state => state.auth)
  const studies = useSelector(state => state.auth?.studies)
  
  const match = useRouteMatch('/')
  const onStudySelectPage = match?.isExact

  const sendEmail = (which) => {
    apiService.aGet(auth, `${globals.appRoot}/email/test/${which}`)
      .then((res) => {
        console.log(res)
        alert(`Sent: [${res?.statusText}]. Check console log.`)
      })
  }

  const handleSetUserDefaults = (idx) => {
    dispatch(actionCreators.storeUserDefaults())
    window.topBar.enqueueSnack({
      id: 'user_' + idx,
      message: 'Defaults Saved',
      to: 3000,
      success: true
    })
  }

  const handleDeleteUserDefaults = (idx) => {
    dispatch(actionCreators.deleteUserDefaults())
    window.topBar.enqueueSnack({
      id: 'user_' + idx,
      message: 'Defaults Deleted',
      to: 3000,
      success: true
    })
  }

  const handleStoreDefaults = () => {
    dispatch(actionCreators.storeDefaults())
  }

  const handleRecycleStudy = () => {
    dispatch(actionCreators.recycleStudy(study?.uid))
  }

  return (
    <div className="basic-menu">
      <div className="avatar">
        <img src={`${globals.appRoot}/avatar/${user?.id}`} alt="User Avatar" />
      </div>

      <Link className="menu-item sign-out" role='link' aria-label='Sign Out' onClick={() => window.topBar.hideMenu()} to={'/sign-out'}>
        Sign Out
        <i className="icon fas fa-sign-out" />
      </Link>

      {!onStudySelectPage ?
        <>
          <div className="separator-with-text">Selected Subscription</div>

          {study?.uid ?
            <NavLink to={`/`} className={'menu-item'} role='link' aria-label='change studies'>
              <i className='icon fal fa-exchange' />
              {study?.label}
            </NavLink>
            :
            <NavLink to={`/`} className={'menu-item'} role='link' aria-label='change studies'>
              <i className='icon fal fa-exchange' />
              Select study...
            </NavLink>
          }

          {false && studies != null
            ? studies.map(s => (
              <NavLink
                key={s.uid}
                to={`/study/${s.uid}/`}
                className={'menu-item'}
                activeClassName="selected"
              >
                {s.label}
              </NavLink>
            ))
            : null}
          
        </>
        : null
      }

      <div className="separator-with-text">Theme</div>

      <a className="menu-item" role='link' aria-label='theme light' onClick={() => changeTheme('light')}>
        Light
        <i className="icon fal fa-address-card" />
      </a>
      <a className="menu-item" role='link' aria-label='theme dark' onClick={() => changeTheme('dark')}>
        Dark
        <i className="icon fas fa-address-card" />
      </a>

      <div className="separator-with-text">Manage</div>

      <Link
        className="menu-item"
        to={'/profile/edit'}
        role='link' aria-label='edit profile'
      >
        Edit Profile
      </Link>

      <Link
        className="menu-item"
        to={'/account/change-password'}
        role='link' aria-label='change password'
      >
        Change Password
        <i className="icon fal fa-key" />
      </Link>

      {study.isStudyAdmin ? <>
        <Link
          className="menu-item"
          to={`/study/${study?.uid}/explore/license settings`}
          role='link' aria-label='license settings'
        >
          License Settings
          <i className="icon fal fa-sliders-v-square" />
        </Link>
      </> : null}

      <a className="menu-item"
        role='link' aria-label='set user defaults'
        onClick={(ev, idx) => handleSetUserDefaults(idx)}
      >
        Set User Defaults
        <i className="icon fal fa-tasks" />
      </a>

      <a className="menu-item"
        role='link' aria-label='delete user defaults'
        onClick={(ev, idx) => handleDeleteUserDefaults(idx)}
      >
        Delete User Defaults
        <i className="icon fal fa-trash-alt" />
      </a>

      {user.isSuperAdmin ? <>
        <div className="separator-with-text">
          Super Administration <i className="fa fa-lock-alt" />
        </div>

        <Link
          className="menu-item"
          to={'/account/manage'}
          role='link' aria-label='users and accounts'
        >
          Users and Accounts
          <i className="icon fal fa-user-chart" />
        </Link>
        <Link
          className="menu-item"
          to={'/account/manage-users'}
          role='link' aria-label='manage users'
        >
          Manage Users
          <i className="icon fal fa-users-cog" />
        </Link>

        <div className="separator-with-text">
          Email testing <i className="fa fa-lock-alt" />
        </div>

        {[
          { key: "registration" },
          { key: "welcome" },
          { key: "passwordReset" },
          { key: "signupRequest" },
        ].map(entry => <a className="menu-item" key={entry.key}
          onClick={() => {
            sendEmail(entry.key)
          }}
        >
          Send test email: {entry.key} <i className="icon fal fa-paper-plane" />
        </a>)}

        {study?.uid ? <>
          <div className="separator-with-text">
            Dev Administration <i className="fa fa-lock-alt" />
          </div>

          <Link
            className="menu-item"
            to={`/study/${study?.uid}/meta`}
            role='link' aria-label='edit meta'
          >
            Edit Study Meta [{study?.folder}]
          </Link>

          <Link
            className="menu-item"
            to={`/study/${study?.uid}/tasks`}
            role='link' aria-label='view study tasks'
          >
            View Study Tasks [{study?.folder}]
          </Link>

          <a className="menu-item"
            role='link' aria-label='set license defaults'
            onClick={handleStoreDefaults}
          >
            Set License Defaults ({`All ${study?.label}`})
          </a>

          <a className="menu-item"
            role='link' aria-label='recycle license'
            onClick={handleRecycleStudy}
          >
            Recycle License ({study?.label})
            <i className="icon fal fa-recycle" />
          </a>
        </> : null}
      </> : null}

      <div className="separator" />
    </div>
  )
}

 
